import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import { setAppCookie } from '@/api/index';

const PUBLIC_REDIRECT_ROUTES = new Set([
  'onboarding-your-digital-coin',
  'merchant-invitation',
  'ai-signup'
]);

export class PublicRoutesRedirect implements IRouterMiddleware {
  canActivate(to: MiddlewareRoute): boolean {
    return (
      PUBLIC_REDIRECT_ROUTES.has(to.name as string) ||
      to.path.includes('/business-setup')
    );
  }

  async execute(
    _to: MiddlewareRoute,
    _from: MiddlewareRoute,
    _next: MiddlewareCallback
  ): Promise<void> {
    setAppCookie('instore');
    window.location.reload();
  }
}
